import { render, staticRenderFns } from "./Strates.vue?vue&type=template&id=c8439934&"
import script from "./Strates.vue?vue&type=script&lang=js&"
export * from "./Strates.vue?vue&type=script&lang=js&"
import style0 from "./Strates.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports